export default "__VITE_ASSET__GKbRaZiU__"